export const RECEIVE_SESSION = 'session/receive-session';
export const SET_AVATAR='session/set-avatar';
export const SET_DATA_USER = 'session/set-data-user';